import type { ReactNode } from 'react';

type Width = 'narrow' | 'base' | 'wide';

export function Container({
  children,
  width = 'base',
  className,
}: {
  children: ReactNode;
  width?: Width;
  className?: string;
}) {
  return (
    <div className={`ds-container ds-container--${width}${className ? ` ${className}` : ''}`}>
      {children}
    </div>
  );
}
